import { useRouter } from "next/router";
import { useState } from "react";
import Button from "src/components/Common/Button";
import { PopupAds } from "sunday-component";
import { getAppCookie, setAppCookie } from "src/utils/cookies";
import { PopupAdsGlobalStyle } from "./PopupAdsContent.styled";

const MAX_AGE_DAYS = parseInt(
  process.env.NEXT_PUBLIC_POPUP_ADS_MAX_AGE_DAYS || "3",
  10
);

const PopupAdsContent = ({ content, name = "popup_ads" }: any) => {
  const router = useRouter();
  const [isClickOnPopup, setIsClickOnPopup] = useState(false);
  const now = new Date();
  const popup = content?.popup.items?.find((item) => {
    const popupStart = new Date(item.startDate);
    const popupEnd = new Date(item.endDate);
    return (
      !!item.startDate && !!item.endDate && now >= popupStart && now <= popupEnd
    );
  });

  const cookieName = `${name}_closed`;
  const closeAdsCookie = getAppCookie(
    cookieName,
    router.query.channelPath as string
  );

  const isPopupVisible =
    !!popup && content?.popup.enabled && closeAdsCookie !== "1";

  const lang = router.locale || "th";
  const popupUrl = popup?.imageUrl[lang];
  const campaignUrl = popup?.campaignUrl?.[lang];

  const handleClosePopup = () => {
    setIsClickOnPopup(true);
    setAppCookie(cookieName, "1", router.query.channelPath as string, {
      maxAge: 60 * 60 * 24 * MAX_AGE_DAYS,
    });
  };

  if (popupUrl && isPopupVisible && !isClickOnPopup) {
    return (
      <Button onClick={handleClosePopup} data-testid="popup-ads">
        <PopupAdsGlobalStyle />
        <PopupAds img={popupUrl} href={campaignUrl} />
      </Button>
    );
  }
  return <></>;
};

export default PopupAdsContent;
